import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function RequireRole({ allowed = [] }) {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;

  const role = (user.access_type || "").toUpperCase();
  const ok = allowed.map(r => r.toUpperCase()).includes(role);

  if (!ok) return <Navigate to={role === "ADMIN" ? "/usuarios" : "/dashboard"} replace />;

  return <Outlet />;
}
